import { render, staticRenderFns } from "./PlatformSidebar.vue?vue&type=template&id=64c893cf&scoped=true&"
import script from "./PlatformSidebar.vue?vue&type=script&lang=js&"
export * from "./PlatformSidebar.vue?vue&type=script&lang=js&"
import style0 from "./PlatformSidebar.vue?vue&type=style&index=0&id=64c893cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c893cf",
  null
  
)

export default component.exports